import { render, staticRenderFns } from "./schoolsCtaBtns.vue?vue&type=template&id=233241f0&"
import script from "./schoolsCtaBtns.vue?vue&type=script&lang=js&"
export * from "./schoolsCtaBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports